import { ShopifyConnect } from '@/pages/onboarding/connect/ShopifyConnect';
import { Modal, type ModalProps } from '@/components/modal/modal';
import { LoadingState } from '@/components/ui/loading-state';
import { Button, Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  reconnect?: boolean;
  loading?: boolean;
  error?: boolean;
  onRetry?: () => void;
  finalFocusEl?: ModalProps['finalFocusEl'];
}

/** The shared explanation for every unavailable affiliation entry. */
export function AffiliationAvailabilityModal({
  isOpen,
  onClose,
  reconnect,
  loading,
  error,
  onRetry,
  finalFocusEl,
}: Props) {
  const { t } = useTranslation();
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      finalFocusEl={finalFocusEl}
      isCentered
      maxWidth="500px"
      dialogContentProps={{ width: 'calc(100% - 32px)' }}
      title={t(reconnect ? 'integrations.shopify.modal.title' : 'affiliation.availability.title')}
    >
      {loading ? (
        <LoadingState message={t('affiliation.availability.loading')} />
      ) : error ? (
        <Text color="inkMuted">{t('affiliation.availability.error')}</Text>
      ) : reconnect ? (
        <ShopifyConnect error={null} />
      ) : (
        <Text color="inkMuted">{t('affiliation.availability.body')}</Text>
      )}
      <Flex justify="flex-end" gap={3} mt={6}>
        {error && (
          <Button variant="outline" onClick={onRetry}>
            {t('common.retry')}
          </Button>
        )}
        <Button onClick={onClose}>{t('affiliation.availability.acknowledge')}</Button>
      </Flex>
    </Modal>
  );
}
